import { useEffect, useRef, useState } from "react";
import { Add_cart, ListSVG, Sub_cart } from "../../../../assets/icons";
import useAppAccessor from "../../../../hooks/useappAccessor";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import { postCheckout } from "../../../../services/shopcom.service";
import { setProductsInCart } from "../../interaction.actions";
import CartListView from "./components/cartListView";
import CartSVG from "./components/cartSVG";
import DollarSVG from "./components/dollarSVG";
import ImageSilder from "./components/imageSilder";
import { countryMap } from "./map/country";
import { languageMap } from "./map/language";
import { addCurrencyFormat } from "../../../../utils/currency.util";
import { getBrandTheme } from "../../../../utils/brand.util";

const decimalComponent = (number: any) => {
  if (number == undefined) return;
  // Add .00 to round numbers
  if (
    typeof number === "string" &&
    !number.includes(".") &&
    !number.includes("-") &&
    !number.includes(",")
  ) {
    number = addCurrencyFormat(number)
  }

  if (number.includes("-")) {
    const numb1: any = number.toString().split("-")[0];
    const numb2: any = number.toString().split("-")[1];
    // Add .00 to round numbers in range
    const [integerPart, decimalPart] = numb1.toString().includes(".")
      ? numb1.toString().split(".")
      : [numb1.toString(), "00"];
    const [integerPart_2, decimalPart_2] = numb2.toString().includes(".")
      ? numb2.toString().split(".")
      : [numb2.toString(), "00"];

    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {`${integerPart}.`}
          <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
          >{`${decimalPart}`}</span>
        </div>
        -
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15, marginLeft: 5 }}
        >
          {`${integerPart_2}.`}
          <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
          >{`${decimalPart_2}`}</span>
        </div>
      </div>
    );
  } else if (number.includes(",")) {
    // Handle comma-separated numbers
    const [integerPart_3, decimalPart_3] = number.toString().includes(",")
      ? number.toString().split(",")
      : [number.toString(), "00"];
    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {`${integerPart_3},`}
          <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
          >{`${decimalPart_3}`}</span>
        </div>
      </div>
    );
  } else {
    // Handle regular numbers
    var [integerPart_3, decimalPart_3] = number.toString().includes(".")
      ? number.toString().split(".")
      : [number.toString(), "00"];
    if (decimalPart_3?.includes(" ")) {
      decimalPart_3 = decimalPart_3.split(" ")[0];
    }
    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {`${integerPart_3}.`}
          <span
            className="text-[10px] font-semibold"
            style={{ position: "absolute", bottom: 3 }}
          >{`${decimalPart_3}`}</span>
        </div>
      </div>
    );
  }
};

const InteractionShoppingCartTranont = (props: any) => {
  const [qtyNumber, setQtyNumber] = useState(1);
  const [totalNum, setTotalNum] = useState(1);
  const [isShowCart, setIsShowCart] = useState(props.showCart ?? false);
  const [images, setImages] = useState<any>([]);
  const [mainImage, setMainImage] = useState<any>("");
  const [currentOption, setCurrentOption] = useState<any>(null);
  const { getInteractions, getUserData, getLiveMainData } = useAppAccessor();
  const { joinWithAttendeeData } = getLiveMainData();
  const { client, referrer_user } = getUserData();
  const { productDetail, productsInCart } = getInteractions();
  const [displayShortDes, setDisplayShortDes] = useState(false);
  const dispatch = useAppDispatch();
  const [showSelection, setShowSelection] = useState(false);
  const [selectedOption, setSelectedOption] = useState(false);
  const [added, setAdded] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);
  const [maskHeight, setMaskHeight] = useState(
    document.getElementById("idVideoRoomContainer")?.offsetHeight ?? 2500
  );

  const elementRef = useRef<HTMLDivElement>(null);
  const [elementHeight, setElementHeight] = useState<number>(625);

  const [selectedPack, setSelectedPack] = useState<any>(null);
  const [selectedFlavor1, setSelectedFlavor1] = useState<string>("");
  const [selectedFlavor2, setSelectedFlavor2] = useState<string>("");

  useEffect(() => {
    if (elementRef.current) {
      setElementHeight(elementRef.current.offsetHeight);
    }
  }, []);

  useEffect(() => {
    const iFrameContainer = document.getElementById("iFrameContainer");
    if (iFrameContainer) {
      iFrameContainer.scrollTop = 0;
    }
  }, [isShowCart]);


  const handleAddToCartClick = () => {
    if (!isSelectionComplete()) return;

    setShowSelection(true);

    //Handle the multi packs
    if (productDetail?.multiPacks && selectedPack) {
      if (selectedPack.name === "Two-Pack") {
        if (!selectedFlavor1 || !selectedFlavor2) {
          return;
        }

        //Handle the same flavor
        let bundle = selectedPack.bundles.find((b: any) =>
          b.options.includes(selectedFlavor1)
        );

        //Handle the different flavor
        if (selectedFlavor1 !== selectedFlavor2) {
          bundle = selectedPack.bundles.find(
            (b: any) =>
              b.options.length === 2 &&
              b.options.includes(selectedFlavor1) &&
              b.options.includes(selectedFlavor2)
          );
        }

        if (bundle) {
          bundle = {
            ...bundle,
            sku: bundle.pid,
          }
          let cartProducts = productsInCart;
          const existingProduct = cartProducts.find((item: any) => item.sku === bundle.sku);
          
          if (existingProduct) {
            // Calculate new quantity and cap at maxQty if needed
            let newQuantity = existingProduct.quantity + qtyNumber;
            if (productDetail?.maxQty && newQuantity > productDetail.maxQty) {
              newQuantity = productDetail.maxQty;
            }
            
            // Update existing product quantity
            cartProducts = cartProducts.map((item: any) => {
              if (item.sku === bundle.sku) {
                return {
                  ...item,
                  quantity: newQuantity,
                };
              }
              return item;
            });
            setAdded(true);
          } else {
            // Cap initial quantity at maxQty if needed
            let finalQuantity = qtyNumber;
            if (productDetail?.maxQty && finalQuantity > productDetail.maxQty) {
              finalQuantity = productDetail.maxQty;
            }
            
            // Add new product
            setAdded(false);
            let product = {
              id: productDetail?.id,
              name: productDetail?.name + (selectedPack?.name ? " " + selectedPack?.name : "") + 
                (selectedFlavor1 === selectedFlavor2 
                  ? ` (2x ${selectedFlavor1})` 
                  : ` (${bundle?.options.join(" & ")})`),
              price: selectedPack?.pricing.retail,
              priceString: selectedPack?.pricing.retail.toString(),
              sku: bundle?.sku,
              quantity: finalQuantity,
              imageUrl: productDetail?.imageUrl,
              options: bundle,
              locale: productDetail?.locale,
              maxQty: productDetail?.maxQty,
              nfr: productDetail?.nfr
            };
            cartProducts.push(product);
          }

          setTimeout(() => {
            var total = 0;
            productsInCart.map((item: any) => {
              total += item.quantity;
            });
            setTotalNum(total);
          }, 1000);
          dispatch(setProductsInCart(cartProducts));
        }
      } else {
        if (!currentOption) {
          return;
        }
        addToCart();
      }
    } else {
      addToCart();
    }

    setTimeout(() => {
      setShowSelection(false);
    }, 5000);
  };

  useEffect(() => {
    var total = 0;
    productsInCart.map((item: any) => {
      total += item.quantity;
    });
    setTotalNum(total);
  }, [isShowCart]);

  useEffect(() => {
    // console.log("productsInCart in redux====>Main",productsInCart)
    var total = 0;
    productsInCart.map((item: any) => {
      total += item.quantity;
    });
    setTotalNum(total);
  }, [productsInCart]);

  useEffect(() => {
    if (ref.current) {
      const height = ref.current.offsetHeight;
      if (document.getElementById("idVideoRoomContainer")?.offsetHeight) {
        if (
          document.getElementById("idVideoRoomContainer")!.offsetHeight >=
          height
        ) {
          setMaskHeight(
            document.getElementById("idVideoRoomContainer")!.offsetHeight + 200
          );
        }
      }
    }
  }, [displayShortDes]);

  useEffect(() => {
    if (ref.current) {
      const height = ref.current.offsetHeight;
      if (document.getElementById("idVideoRoomContainer")?.offsetHeight) {
        if (
          document.getElementById("idVideoRoomContainer")!.offsetHeight >=
          height
        ) {
          setMaskHeight(
            document.getElementById("idVideoRoomContainer")!.offsetHeight + 200
          );
        }
      }
    }
  }, []);

  useEffect(() => {
    console.log("productDetail Data in redux====>Main", productDetail);
    let imagesArr: any[] = [];
    // productDetail?.options?.map((item:any)=>{
    //   item?.images?.map((p:any) => {
    //     imagesArr.push(p.sizes[0].url);
    //   })
    // });

    setMainImage(productDetail?.imageUrl);

    if (productDetail?.options && productDetail?.options.length == 1) {
      setCurrentOption(productDetail?.options[0]);

      let imagesArr: any[] = [productDetail?.imageUrl];
      if (currentOption && currentOption.images) {
        currentOption.images?.map((item: any) => {
          // item?.images?.sizes.map((p:any) => {
          imagesArr.push(item.sizes[0].url);
          // })
        });
      }
      setMainImage(imagesArr[0]);
      setImages(imagesArr);
      if (
        productDetail &&
        productDetail?.options &&
        productDetail?.options.length > 0
      ) {
        let cartProducts = productsInCart;
        if (
          cartProducts.find(
            (item: any) => item.sku === productDetail?.options[0].sku
          )
        ) {
          setAdded(true);
        } else {
          setAdded(false);
        }
      }
    } else {
      setImages([]);
      setCurrentOption(null);
    }
  }, [productDetail]);

  useEffect(() => {
    if (productDetail?.fromCarsoul) {
      // if (isShowCart) {
      setIsShowCart(false);
      // } else {
      //   setIsShowCart(true);
      // }
    }
  }, [productDetail]);

  useEffect(() => {
    if (currentOption && currentOption.images) {
      let imagesArr: any[] = [productDetail?.imageUrl];
      currentOption.images?.map((item: any) => {
        imagesArr.push(item.sizes[0].url);
      });

      // Function to extract the unique identifier from the URL
      const extractIdentifier = (url: string) => {
        const match = url.match(/([a-fA-F0-9]{10})(?=\.jpg)/);
        return match ? match[1] : null;
      };

      // Use a Set to track unique identifiers
      const uniqueIdentifiers = new Set();
      const uniqueImagesArr = imagesArr.filter((url) => {
        const identifier = extractIdentifier(url);
        if (identifier && !uniqueIdentifiers.has(identifier)) {
          uniqueIdentifiers.add(identifier);
          return true;
        }
        return false;
      });

      setMainImage(imagesArr[0]);
      setImages(uniqueImagesArr);
    }
  }, [currentOption]);

  //Handle normal product
  const addToCart = () => {
    let cartProducts = productsInCart;
    const existingProduct = cartProducts.find((item: any) => item.sku === currentOption?.sku);
    
    if (existingProduct) {
      // Calculate new quantity
      let newQuantity = existingProduct.quantity + qtyNumber;
      
      // Cap the quantity at maxQty if it would exceed
      if (productDetail?.maxQty && newQuantity > productDetail.maxQty) {
        newQuantity = productDetail.maxQty;
      }
      
      // Update existing product quantity
      cartProducts = cartProducts.map((item: any) => {
        if (item.sku === currentOption?.sku) {
          return {
            ...item,
            quantity: newQuantity,
          };
        }
        return item;
      });
    } else {
      // Cap initial quantity at maxQty if needed
      let finalQuantity = qtyNumber;
      if (productDetail?.maxQty && finalQuantity > productDetail.maxQty) {
        finalQuantity = productDetail.maxQty;
      }
      
      // Add new product
      setAdded(false);
      let product = {
        id: productDetail?.id,
          name: productDetail?.name !== currentOption?.name ? productDetail?.name + " (" + currentOption?.name + ")" : productDetail?.name + " (" + productDetail?.shortDescription + ")",
          price: currentOption?.price,
          priceString: currentOption?.priceString,
        sku: currentOption?.sku,
        quantity: finalQuantity,
        imageUrl: productDetail?.imageUrl,
        options: currentOption,
        locale: productDetail?.locale,
        maxQty: productDetail?.maxQty,
        nfr: productDetail?.nfr
      };
      cartProducts.push(product);
    }

    setTimeout(() => {
      var total = 0;
      productsInCart.map((item: any) => {
        total += item.quantity;
      });
      setTotalNum(total);
    }, 1000);
    dispatch(setProductsInCart(cartProducts));
  };


  const handleQtyOnclick = (isIncrease: boolean) => {
    if (isIncrease) {
      if (productDetail?.maxQty && qtyNumber < productDetail.maxQty) {
        setQtyNumber(qtyNumber + 1);
      }
    } else {
      if (qtyNumber > 1) {
        setQtyNumber(qtyNumber - 1);
      }
    }
  };

  const [showCheckoutModal, setShowCheckoutModal] = useState(false);
  const [checkoutUrl, setCheckoutUrl] = useState("");

  // 检查出模态框组件
  const CheckoutModal = ({
    url,
    onClose,
  }: {
    url: string;
    onClose: () => void;
  }) => {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          zIndex: 9999,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "10px",
            padding: "20px",
            width: "90%",
            maxWidth: "400px",
            textAlign: "center",
          }}
        >
          <h3 style={{ margin: "10px 0 20px" }}>Complete your checkout</h3>
          <p style={{ margin: "10px 0", fontSize: "14px" }}>
            Click the button below to open checkout in a new tab
          </p>
          <div style={{ margin: "20px 0" }}>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                padding: "10px 20px",
                backgroundColor: getBrandTheme(client).primary,
                color: "white",
                textDecoration: "none",
                borderRadius: "5px",
                fontWeight: "bold",
              }}
            >
              Go to Checkout
            </a>
          </div>
          <button
            onClick={onClose}
            style={{
              marginTop: "15px",
              padding: "8px 15px",
              border: "1px solid #ccc",
              borderRadius: "5px",
              background: "none",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    );
  };

  const doCheckOut = () => {
    let products: Array<any> = [];
    productsInCart.map((item: any) => {
      let options: Array<any> = [];
      options.push({ sku: item.options.sku });
      products.push({
        id: item.id.toString(),
        quantity: item.quantity,
        locale: item.locale,
        type: "PROD",
        nfr: item.nfr,
        userOptions: {
          appSourceId: "hussle",
        },
        option: options,
      });
    });

    // Construct the URL
    const baseUrl = products[0]?.locale 
      ? `https://www.tranont.com/${transformLocale(products[0].locale)}?bag=`
      : "https://www.tranont.com/?bag=";
    const productStrings = products
      .map((product) => {
        return `o:${product.id}:${product.option[0].sku}:${product.quantity}`;
      })
      .join("_");

    let shareCode = "";

    if (referrer_user != null && referrer_user?.third_party_username) {
      shareCode = referrer_user!.third_party_username;
    } else if (
      joinWithAttendeeData != null &&
      joinWithAttendeeData!.issuer_metadata != null &&
      joinWithAttendeeData?.issuer_metadata?.third_party_username
    ) {
      shareCode = joinWithAttendeeData?.issuer_metadata?.third_party_username;
    }

    const checkoutUrl = `${baseUrl}${productStrings}${
      shareCode ? `&share=${shareCode}` : ""
    }${
      products.every((product: any) => product.nfr === true) ? '&nfr=1' : ''
    }`;

    console.log("checkoutUrl", checkoutUrl);

    openNewTab(checkoutUrl);
  };

  const transformLocale = (locale: string) => {
    if (locale === "en_US") {
      return "en";
    }

    return locale.replace(/_/g, '-');
  };

  // 解决Safari浏览器中window.open无效的问题
  const openNewTab = (url: string) => {
    
    // 检测是否为iOS设备
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
    // 检测是否为移动设备
    const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent) || isIOS;

    if (isMobileDevice) {
      // 对于移动设备，特别是Safari，显示模态框引导用户操作
      setCheckoutUrl(url);
      setShowCheckoutModal(true);
    } else {
      // 桌面浏览器使用a标签模拟点击
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.rel = "noopener noreferrer";

      // 将a标签添加到文档中
      document.body.appendChild(link);

      // 模拟点击
      link.click();

      // 从文档中移除a标签
      setTimeout(() => {
        document.body.removeChild(link);
      }, 100);
    }
  };

  const isMobile = /Mobi|Android/i.test(navigator.userAgent);
  const { language } = getUserData();

  const productDetailComponent = () => {
    return (
      !isShowCart && (
        <div
          className="h-full w-full bg-white"
          style={{ position: "relative" }}
        >
          {showSelection && (
            <div
              ref={elementRef}
              style={
                isMobile
                  ? {
                      zIndex: 10009,
                      background: "white",
                      borderRadius: "5px",
                      position: "fixed",
                      top: "120px",
                      left: "10px",
                      height: "70px",
                      width: "calc(100% - 20px)",
                    }
                  : {
                      zIndex: 10009,
                      background: "white",
                      borderRadius: "5px",
                      position: "fixed",
                      top: "120px",
                      marginLeft: "20px",
                      height: "70px",
                      width: "calc(23% - 40px)",
                    }
              }
              onClick={() => setShowSelection(false)}
            >
              <div className="flex items-center justify-center">
                <img
                  src={productDetail?.imageUrl}
                  style={{
                    width: "50px",
                    height: "50px",
                    position: "absolute",
                    top: "10px",
                    left: "10px",
                    borderRadius: "5px",
                  }}
                ></img>
                <div
                  style={{
                    width: "calc(100% - 80px)",
                    marginLeft: "50px",
                    marginTop: "15px",
                  }}
                >
                  <div
                    style={{
                      color: "black",
                      fontSize: "14px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    dangerouslySetInnerHTML={{ __html: productDetail?.name }}
                  />
                  {/* <p style={{color:'black', fontSize:'14px', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>{productDetail?.name}</p> */}
                  <p
                    style={{
                      color: getBrandTheme(client).primary,
                      fontSize: "14px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {language["added_to_cart"]}
                  </p>
                </div>
              </div>
            </div>
          )}
          {showSelection && (
            <div
              onClick={() => {
                setShowSelection(false);
              }}
              className="w-full"
              style={
                isMobile
                  ? {
                      zIndex: 10008,
                      height: maskHeight + "px",
                      background: "black",
                      opacity: 0.25,
                      position: "fixed",
                      overflowY: "hidden",
                      top: "-15px",
                    }
                  : {
                      zIndex: 10008,
                      height: maskHeight + "px",
                      background: "black",
                      opacity: 0.25,
                      position: "absolute",
                      overflowY: "hidden",
                    }
              }
            ></div>
          )}
          <div style={{ height: "64px" }}></div>
          <div className="w-full h-[147px] flex items-center justify-center">
            <img src={mainImage} className="h-full"></img>
          </div>

          {/* {((productDetail?.options.length > 1 && currentOption != null) ||
            productDetail?.options.length == 1) && (
            <ImageSilder
              images={images}
              onChangeMainImage={(img: any) => setMainImage(img)}
            ></ImageSilder>
          )} */}
          <div
            id={"content"}
            className="px-7 py-4 font-medium bg-white"
            style={{ position: "relative" }}
          >
            {/* Product Title */}
            <h1 className="text-2xl font-semibold mb-4">
              <div dangerouslySetInnerHTML={{ __html: productDetail?.name }} />
            </h1>

            {/* Price Display */}
            <div className="mb-6">
              <span
                className="text-2xl font-bold text-gray-900"
              >
                {selectedPack?.name === "Two-Pack"
                  ? decimalComponent(
                      addCurrencyFormat(selectedPack.pricing.retail.toString())
                    )
                  : currentOption != null
                  ? decimalComponent(
                      addCurrencyFormat(currentOption?.priceString)
                    )
                  : productDetail?.minimumPriceString &&
                    productDetail?.maximumPriceString
                  ? decimalComponent(
                      productDetail?.minimumPriceString +
                        "-" +
                        productDetail?.maximumPriceString
                    )
                  : productDetail?.minimumPriceString
                  ? decimalComponent(productDetail?.minimumPriceString)
                  : productDetail?.maximumPriceString
                  ? decimalComponent(productDetail?.maximumPriceString)
                  : null}
              </span>
            </div>

            {/* Pack Selection - Moved above flavor selection */}
            {productDetail?.multiPacks && (
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Select Pack
                </label>
                <select
                  value={selectedPack?.name || ""}
                  onChange={(e: any) => {
                    const selected = productDetail.multiPacks.packs.find(
                      (pack: any) => pack.name === e.target.value
                    );
                    setSelectedPack(selected);
                    setSelectedFlavor1("");
                    setSelectedFlavor2("");
                    setSelectedOption(false);
                    setCurrentOption(null);
                  }}
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                >
                  <option value="" disabled>
                    {language["please_select"]} Pack
                  </option>
                  {productDetail.multiPacks.packs.map((pack: any) => (
                    <option key={pack.name} value={pack.name}>
                      {pack.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* Single item or non-Two-Pack selections - Moved below pack selection */}
            {(!productDetail?.multiPacks || 
              (selectedPack && selectedPack.name !== "Two-Pack")) && 
              productDetail?.options.length > 1 &&
              productDetail?.selections?.map((selection: any) => (
                <div className="mb-6" key={selection.id}>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Select Flavor
                  </label>
                  <select
                    value={currentOption?.sku || ""}
                    onChange={(e: any) => {
                      const selectedOption = productDetail?.options.find(
                        (item: any) => item.sku == e.target.value
                      );
                      setSelectedOption(true);
                      setCurrentOption(selectedOption);

                      if (productDetail?.options.length > 0) {
                        let cartProducts = productsInCart;
                        if (
                          cartProducts.find(
                            (item: any) => item.sku === e.target.value
                          )
                        ) {
                          setAdded(true);
                        } else {
                          setAdded(false);
                        }
                      }
                    }}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                  >
                    <option value="" disabled>
                      {language["please_select"]} Flavor
                    </option>
                    {productDetail?.options?.map((item: any) => (
                      <option
                        key={item.sku}
                        disabled={item?.canBeAddedToCart == false}
                        value={item?.sku}
                      >
                        {item?.name + ` (${item?.priceString})`}
                      </option>
                    ))}
                  </select>
                </div>
              ))}

            {/* Two-Pack Flavor Selections - Keep after pack selection */}
            {selectedPack?.name === "Two-Pack" && (
              <div className="space-y-4 mb-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    First Flavor
                  </label>
                  <select
                    value={selectedFlavor1}
                    onChange={(e: any) => setSelectedFlavor1(e.target.value)}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                  >
                    <option value="" disabled>
                      {language["please_select"]} Flavor 1
                    </option>
                    {selectedPack.flavors.map((flavor: string) => (
                      <option key={flavor} value={flavor}>
                        {flavor}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Second Flavor
                  </label>
                  <select
                    value={selectedFlavor2}
                    onChange={(e: any) => setSelectedFlavor2(e.target.value)}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                  >
                    <option value="" disabled>
                      {language["please_select"]} Flavor 2
                    </option>
                    {selectedPack.flavors.map((flavor: string) => (
                      <option key={flavor} value={flavor}>
                        {flavor}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            {/* Quantity Selector */}
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Quantity
              </label>
              <div className="flex items-center space-x-4">
                <button
                  onClick={() => handleQtyOnclick(false)}
                  className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-all duration-200"
                >
                  <span className="text-xl font-medium">-</span>
                </button>
                <span className="text-lg font-medium w-12 text-center">{qtyNumber}</span>
                <button
                  onClick={() => handleQtyOnclick(true)}
                  className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-all duration-200"
                >
                  <span className="text-xl font-medium">+</span>
                </button>
              </div>
            </div>

            {/* Cashback Info */}
            {currentOption && currentOption.cashbackString && (
              <div className="flex items-center space-x-2 mb-6 bg-gray-50 p-4 rounded-lg">
                <span className="text-sm">{currentOption.cashbackString}</span>
                <DollarSVG width="20px" stroke={getBrandTheme(client).primary} />
                <span className="text-sm">{language["cashback_label"]}</span>
              </div>
            )}

            {/* Product Description */}
            <div className="border-t border-gray-200 pt-6">
              <div className="prose max-w-none">
                <div
                  className="text-gray-600"
                  dangerouslySetInnerHTML={
                    displayShortDes
                      ? { __html: productDetail?.shortDescription }
                      : { __html: productDetail?.description }
                  }
                />
                {displayShortDes && productDetail?.shortDescription.endsWith("...") && (
                  <button
                    className="mt-4 text-blue-600 hover:text-blue-800 font-medium transition-colors duration-200"
                    onClick={() => setDisplayShortDes(false)}
                  >
                    {language["see_details"]}
                  </button>
                )}
              </div>
            </div>
          </div>

          {isMobile && (
            <div className="w-full flex items-center justify-center pt-2 pb-2 bg-white">
               <button
                className="pl-6 pr-6 pt-2 pb-2 rounded-full text-white text-sm font-semibold"
                style={
                  isSelectionComplete()
                    ? {
                        backgroundColor: getBrandTheme(client).primary,
                        opacity: 1,
                        minWidth: "160px",
                      }
                    : {
                        backgroundColor: getBrandTheme(client).primary,
                        opacity: 0.5,
                        minWidth: "160px",
                      }
                }
                onClick={() => {
                  if (isSelectionComplete()) {
                    handleAddToCartClick();
                  }
                }}
              >
                {added ? language["update_cart"] : language["add_to_cart"]}
              </button>
            </div>
          )}
          {!isMobile && <div style={{ paddingBottom: "80px" }}></div>}

          {!isMobile && (
            <div
              className="w-full flex items-center justify-center pt-2 pb-2 bg-white"
              style={{
                position: "fixed",
                bottom: "60px",
                width: isMobile ? "calc(100%)" : "calc(22.5% - 15px)",
                left: isMobile ? "50%" : "auto",
                right: "calc(5% + 10px)",
                transform: isMobile ? "translateX(-50%)" : "none",
                zIndex: 10,
              }}
            >
              <button
                className="pl-6 pr-6 pt-2 pb-2 rounded-full text-white text-sm font-semibold"
                style={
                  isSelectionComplete()
                    ? {
                        backgroundColor: getBrandTheme(client).primary,
                        opacity: 1,
                        minWidth: "160px",
                      }
                    : {
                        backgroundColor: getBrandTheme(client).primary,
                        opacity: 0.5,
                        minWidth: "160px",
                      }
                }
                onClick={() => {
                  if (isSelectionComplete()) {
                    handleAddToCartClick();
                  }
                }}
              >
                {added ? language["update_cart"] : language["add_to_cart"]}
              </button>
            </div>
          )}
        </div>
      )
    );
  };

  // Add this function to check if all required selections are made
  const isSelectionComplete = () => {
    // For multipacks
    if (productDetail?.multiPacks) {
      if (!selectedPack) return false;

      if (selectedPack.name === "Two-Pack") {
        // For Two-Pack, require both flavors
        return Boolean(selectedFlavor1 && selectedFlavor2);
      } else {
        // For one-pack, require an option selection
        return Boolean(currentOption);
      }
    }

    // For single items
    if (productDetail?.options?.length === 1) {
      return true; // Single option items are always selectable
    }

    // For items with multiple options
    return Boolean(currentOption); // Check if an option is selected
  };

  return (
    <div ref={ref} style={{ height: maskHeight }}>
      {showCheckoutModal && (
        <CheckoutModal
          url={checkoutUrl}
          onClose={() => setShowCheckoutModal(false)}
        />
      )}
      <div
        className="h-16 w-full flex justify-between items-center bg-white"
        style={
          isShowCart
            ? {}
            : isMobile
            ? {
                width: "100%",
                position: "fixed",
                borderBottom: "1px solid #e5e7eb",
                zIndex: 100,
                marginTop: "0px",
              }
            : {
                width: "calc(70% / 3 - 25px)",
                position: "fixed",
                borderBottom: "1px solid #e5e7eb",
                zIndex: 100,
              }
        }
      >
        {isShowCart ? (
          <div
            className="ml-10"
            onClick={() => {
              props.toggleProductList(false);
              setIsShowCart(false);
            }}
            style={{ fontSize: "30px" }}
          >
            <img
              src={ListSVG}
              color="black"
              alt="Icon"
              height={33}
              width={33}
              className="cursor-pointer"
            />
          </div>
        ) : (
          <div
            className="ml-10"
            onClick={() => props.toggleProductList(false)}
            style={{ fontSize: "30px" }}
          >
            {"<"}
          </div>
        )}
        <div className="flex-grow text-center">
          {isShowCart ? language["cart_label"] : language["shop_label"]}
        </div>
        {!isShowCart && (
          <div
            className="mr-10"
            style={{ cursor: "pointer", position: "relative" }}
            onClick={() => {
              setIsShowCart(true);
            }}
          >
            <CartSVG width="22px" stroke={getBrandTheme(client).primary}></CartSVG>
            {
              <div
                style={{
                  position: "absolute",
                  top: "-8px",
                  right: "-8px",
                  background: "red",
                  color: "white",
                  borderRadius: "50%",
                  width: "16px",
                  height: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "12px",
                  fontWeight: "500",
                }}
              >
                {totalNum}
              </div>
            }
          </div>
        )}
        {/* {!isShowCart && <div className="mr-10" onClick={() => {setIsShowCart(true);}}><img src={cart} alt="Icon" height={22} width={22} className="cursor-pointer"/></div>}    */}
        {isShowCart && (
          <div
            style={{ width: "22px", height: "22px" }}
            className="mr-10"
            onClick={() => {}}
          ></div>
        )}
        {isShowCart && (
          <div
            style={{
              position: "absolute",
              height: "22px",
              top: "20px",
              right: "12px",
              fontWeight: "500",
            }}
          >
            {totalNum > 1
              ? `${totalNum} ${
                  language["item_label"] == "Item"
                    ? "Items"
                    : language["item_label"]
                }`
              : `${totalNum} ${language["item_label"]} `}
          </div>
        )}
      </div>
      {productDetailComponent()}
      {isShowCart && (
        <div
          className="h-full w-full  bg-white "
          style={{ position: "relative" }}
        >
          {productsInCart.length > 0 ? (
            <CartListView
              checkoutElem={
                isMobile ? (
                  <div
                    className="w-full flex items-center justify-center pt-2 pb-2"
                    style={
                      totalNum > 0
                        ? {
                            opacity: 1,
                            marginTop: "50px",
                            position: "fixed",
                            bottom: "60px",
                            width: "150px",
                            left: "calc(50% - 75px)",
                          }
                        : {
                            opacity: 0.5,
                            left: "calc(50% - 75px)",
                            marginTop: "50px",
                            position: "fixed",
                            bottom: "60px",
                            width: "150px",
                          }
                    }
                  >
                    <button
                      style={{ backgroundColor: getBrandTheme(client).primary }}
                      className="pl-6 pr-6 pt-2 pb-2 rounded-full text-white text-sm font-semibold"
                      onClick={() => {
                        doCheckOut();
                      }}
                    >
                      CheckOut
                    </button>
                  </div>
                ) : (
                  <div
                    className="w-full flex items-center justify-center pt-2 pb-2"
                    style={{
                      position: "fixed",
                      bottom: "60px",
                      width: isMobile ? "calc(100%)" : "calc(22.5% - 15px)",
                      left: isMobile ? "50%" : "auto",
                      right: "calc(5% + 10px)",
                      transform: isMobile ? "translateX(-50%)" : "none",
                      zIndex: 10,
                      background: "white",
                      paddingTop: "8px",
                      paddingBottom: "8px",
                    }}
                  >
                    <button
                      style={{
                        backgroundColor: getBrandTheme(client).primary,
                        minWidth: "160px",
                      }}
                      className="pl-6 pr-6 pt-2 pb-2 rounded-full text-white text-sm font-semibold"
                      onClick={() => {
                        doCheckOut();
                      }}
                    >
                      CheckOut
                    </button>
                  </div>
                )
              }
            ></CartListView>
          ) : (
            <div style={{ marginTop: "0px", textAlign: "center" }}>
              {language["no_items"]}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default InteractionShoppingCartTranont;
